export function getPayOffProposalEndpoint(): string {
    return '/quotation/proposal';
}
